// No tokens or identity in storage: only a signal to other tabs to recheck the cookie.
export const AUTH_EXPIRED = 'iw:session-expired';
export const AUTH_STORAGE_KEY = 'iw-auth-event';
let revision = 0;
export const sessionRevision = () => revision;
export const advanceSessionRevision = () => ++revision;
export function signalSessionExpired(observedRevision) {
  if (observedRevision === revision) window.dispatchEvent(new CustomEvent(AUTH_EXPIRED, { detail: observedRevision }));
}
export function notifyAuthTabs(type) {
  try { localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ type, nonce: `${Date.now()}-${Math.random()}` })); } catch (_) {}
}
